import React, { useEffect, useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import {
  getCompanyType,
  getEconomicActivities,
  getPublicCountries,
} from "../../../helpers/dataBackend";
import { setAuthorization } from "../../../helpers/api_helper";

interface ValidationInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const BusinessInformation = ({
  onSubmit,
  onBack,
  data,
}: ValidationInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  // const FlatPickr: React.ComponentType<any> =
  //   require("react-flatpickr").default;

  const [companyType, setCompanyType] = useState<any>([]);
  const [economicActivity, setEconomicActivity] = useState<any>([]);
  const [countries, setCountries] = useState<any[]>([]);

  const getData = async () => {
    const responseCompanyType = await getCompanyType();
    setCompanyType(JSON.parse(responseCompanyType.data));

    const responseEconomicActivity = await getEconomicActivities("");
    setEconomicActivity(JSON.parse(responseEconomicActivity.data));

    const responseCountries = await getPublicCountries();
    setCountries(JSON.parse(responseCountries.data));
    // console.log(responseEconomicActivity);
    // console.log(responseCountries);
    // console.log("Response ", JSON.parse(responseEconomicActivity.data));
  };

  useEffect(() => {
    const responsePublicToken = localStorage.getItem("publicToken");
    // console.log(responsePublicToken);
    setAuthorization(responsePublicToken); // Guardar el token antes de continuar

    getData();
  }, []);

  const today = new Date();
  const isoToday = today.toISOString().split("T")[0];

  const formik: any = useFormik({
    initialValues: {
      legalBusinessName:
        (data.businessInfo && data.businessInfo.legalBusinessName) || "",
      taxDocumentNumber:
        (data.businessInfo && data.businessInfo.taxDocumentNumber) || "",
      businessType: (data.businessInfo && data.businessInfo.businessType) || "",
      economicActivity:
        (data.businessInfo && data.businessInfo.economicActivity) || "",
      address: (data.businessInfo && data.businessInfo.address) || "",
      country: (data.businessInfo && data.businessInfo.country) || "",
      constitutionDate:
        (data.businessInfo && data.businessInfo.constitutionDate) || "",
    },
    validationSchema: yup.object().shape({
      legalBusinessName: yup
        .string()
        .required("Please Enter Your Legal Business Name"),
      taxDocumentNumber: yup
        .string()
        .required("Please Enter Your Tax Document Number"),
      businessType: yup.string().required("Please select your Business Type"),
      economicActivity: yup
        .string()
        .required("Please select your economic Activity"),
      address: yup.string().required("Please Enter Your address"),
      country: yup.string().required("Please Enter Your Country"),
      constitutionDate: yup
        .date()
        .required("Ingresa la fecha de constitucion")
        .max(today, "La fecha no puede estar en el futuro"),
    }),
    onSubmit: (values: any) => {
      // console.log("values", values);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        <Row>
          {/* NOMBRE */}
          <FormGroup className="mb-3">
            <Label htmlFor="legalBusinessName">
              {" "}
              Nombre legal de la empresa{" "}
            </Label>
            <div className="d-flex gap-2">
              <div className="flex-grow-1 bd-highligh">
                <Input
                  type="text"
                  id="legalBusinessName"
                  placeholder="Escriba el nombre legal de la Empresa"
                  defaultValue="AI CORP"
                  name="legalBusinessName"
                  value={formik.values.legalBusinessName || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.legalBusinessName &&
                    formik.errors.legalBusinessName
                      ? true
                      : false
                  }
                />
                {formik.touched.legalBusinessName &&
                formik.errors.legalBusinessName ? (
                  <FormFeedback type="invalid">
                    {formik.errors.legalBusinessName}
                  </FormFeedback>
                ) : null}
              </div>
            </div>
          </FormGroup>
          <FormGroup className="mb-3">
            {/* NUMERO DE INDENTIFICACION FISCAL */}
            <Row>
              <Col lg={6}>
                <Label htmlFor="taxDocumentNumber">
                  {" "}
                  Número de identificación fiscal{" "}
                </Label>
                <Input
                  type="text"
                  id="taxDocumentNumber"
                  placeholder="Escriba el Número de identificación fiscal"
                  name="taxDocumentNumber"
                  value={formik.values.taxDocumentNumber || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.taxDocumentNumber &&
                    formik.errors.taxDocumentNumber
                      ? true
                      : false
                  }
                />
                {formik.touched.taxDocumentNumber &&
                formik.errors.taxDocumentNumber ? (
                  <FormFeedback type="invalid">
                    {formik.errors.taxDocumentNumber}
                  </FormFeedback>
                ) : null}
              </Col>

              {/* TIPO DE EMPRESA */}
              <Col lg={6}>
                <Label htmlFor="businessType"> Tipo de Empresa </Label>
                <div className="d-flex gap-2">
                  <select
                    className="form-control"
                    name="businessType"
                    id="businessType"
                    value={formik.values.businessType || ""}
                    onChange={formik.handleChange}
                  >
                    <option value="" selected disabled>
                      Elige una opcion
                    </option>
                    {companyType.map((item: any) => (
                      <option key={item.code} value={item.code}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {formik.errors.businessType && formik.touched.businessType ? (
                    <span className="text-danger">
                      {formik.errors.businessType}
                    </span>
                  ) : null}
                </div>
              </Col>
            </Row>
          </FormGroup>

          {/* ACTIVIDAD ECONOMICA */}
          <FormGroup className="mb-3">
            <Label htmlFor="economicActivity">
              {" "}
              Actividad económica principal{" "}
            </Label>

            <div className="d-flex gap-2">
              <select
                className="form-control"
                name="economicActivity"
                id="economicActivity"
                value={formik.values.economicActivity || ""}
                onChange={formik.handleChange}
              >
                <option value="" selected disabled>
                  Elige una opcion
                </option>
                {economicActivity.map((item: any) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </select>
              {formik.errors.economicActivity &&
              formik.touched.economicActivity ? (
                <span className="text-danger">
                  {formik.errors.economicActivity}
                </span>
              ) : null}
            </div>
          </FormGroup>

          {/* DIRECCION LEGAL DE LA EMPRESA */}
          <FormGroup
            className="mb-3"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Label htmlFor="address"> Dirección fiscal </Label>
            <Input
              type="text"
              id="address"
              placeholder="Av. del Parque Industrial 1520, Edificio Torre Empresarial, Piso 15, San Salvador"
              name="address"
              value={formik.values.address || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FormGroup>

          {/* PAIS CONSTITUCION */}
          <Col lg={6}>
            <FormGroup className="mb-3">
              <Label htmlFor="country"> País de constitución </Label>

              <div className="d-flex gap-2">
                <select
                  className="form-control"
                  name="country"
                  id="country"
                  value={formik.values.country || ""}
                  onChange={formik.handleChange}
                >
                  <option value="" selected disabled>
                    Elige una opcion
                  </option>
                  {countries.map((item) => (
                    <option
                      id={item.code_iso_31661}
                      value={item.code_iso_31661}
                    >
                      {item.name}
                    </option>
                  ))}
                </select>
                {formik.errors.country && formik.touched.country ? (
                  <span className="text-danger">{formik.errors.country}</span>
                ) : null}
              </div>
            </FormGroup>
          </Col>
          {/* FECHA DE CONSTITUCION */}
          <Col lg={6}>
            <FormGroup className="mb-3">
              <Label htmlFor="constitutionDate">Fecha de constitución</Label>
              <Input
                type="date"
                className="form-control d-block"
                id="constitutionDate"
                name="constitutionDate"
                placeholder="Select date"
                max={isoToday}
                onChange={formik.handleChange}
                value={formik.values.constitutionDate || ""}
              />
              {formik.touched.constitutionDate &&
              formik.errors.constitutionDate ? (
                <span className="text-danger">
                  {formik.errors.constitutionDate}
                </span>
              ) : null}
            </FormGroup>
          </Col>
        </Row>

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {/* <Button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onBack}
          >
            Regresar
          </Button> */}
          <Button type="submit" className="btn btn-primary">
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default BusinessInformation;
